import { gTranslate } from '@lumapps/auto-translation';

import { WidgetState } from '../ducks/type';
import { isBlockHtml, isBlockIntro, isBlockStructuredContent } from './blockPredicates';

export const getWidgetTranslatedData = async (widget: Partial<WidgetState>, widgetType: string, targetLang: string) => {
    const { header, body } = widget;

    return Promise.all([
        header && header.label ? gTranslate({ content: header.label, targetLang }) : null,
        body && isBlockIntro(body, widgetType) && body.text ? gTranslate({ content: body.text, targetLang }) : null,
        body && isBlockHtml(body, widgetType) && body.html
            ? gTranslate({ content: body.html, targetLang, isContentHTML: true })
            : null,
        body && isBlockStructuredContent(body, widgetType) && body.ditaHtmlValues
            ? gTranslate({
                  content: body.ditaHtmlValues,
                  targetLang,
                  isContentHTML: true,
              })
            : null,
    ]).then(([label, text, html, structuredContentHtml]) => {
        const widgetTranslatedData: Partial<WidgetState> = {};

        if (label) {
            widgetTranslatedData.header = { label };
        }

        if (text) {
            widgetTranslatedData.body = { text } as any;
        }

        if (html) {
            widgetTranslatedData.body = { html } as any;
        }

        if (structuredContentHtml) {
            widgetTranslatedData.body = { ditaHtmlValues: structuredContentHtml } as any;
        }

        return widgetTranslatedData;
    });
};
